import api from '@/core/api/client';
import type { CompanyInvoice } from '@/features/companies/api/company-invoices.service';

export type GlobalInvoice = CompanyInvoice & { companyId: string; companyName: string };
export interface InvoiceFilters { page: number; limit: number; currency: string; search?: string; status?: string; gateway?: string; from?: string; to?: string }
export interface InvoiceList { invoices: GlobalInvoice[]; total: number; summary: { received: number; open: number; overdue: number } }
export async function listInvoices(filters: InvoiceFilters): Promise<InvoiceList> {
  return (await api.get<{ data: InvoiceList }>('/invoices', { params: filters })).data.data;
}
